<div class="container">
    <div class="container">
        <div *ngFor="let rowIndex of rows" class="feature-row"
             [ngClass]="{'slide-right': rowIndex % 2 === 0, 'slide-left': rowIndex % 2 !== 0}">
          <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center center">
            <div *ngFor="let feature of img.slice(rowIndex * 3, rowIndex * 3 + 3); let i = index"
                 [fxFlex]="calcFlex()" class="feature-box" [ngClass]="getStyleClass(i)">
              <div [style.background-color]="feature.customField17" class="feature-title"
              [style.font-size]="item.customField39" [ngStyle.lt-md]="{ 'font-size': item.customField40 }">{{ feature.customField15 }}</div>
              <div  [style.background-color]="feature.customField18" class="feature-description"
              [style.font-size]="item.customField37" [ngStyle.lt-md]="{ 'font-size': item.customField38 }">{{ feature.customField16 }}</div>
            </div>
          </div>
        </div>
      </div>
      
</div>
